// src/components/common/Footer.jsx
import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { useSettings } from '../../context/SettingsContext';

const Footer = () => {
  const { siteName } = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'background.paper', // ✅ Dynamic background
        color: 'text.secondary',      // ✅ Dynamic text color
        py: 1.5,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: 13 }}>
        &copy; {currentYear} {siteName}. All rights reserved.
      </Typography>

      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12 }}>
          Developed by{' '}
          <Box component="span" sx={{ color: 'primary.main', fontWeight: 600 }}>
            V-TECH Dev Team
          </Box>
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ height: 16, alignSelf: 'center' }} />
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12 }}>
          v1.0.0
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer;